import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import HandleChange from "../../../../../Helpers/HandleChange";
import {MATERIAL_CONTROL_ITEM_VALIDATION_MODEL, RECORD_DELIVERY_MODEL} from "../../Model/Model";
import {PHOTO_PICKER_MODEL} from "../../../../../components/PhotoPicker/SubComponent/Models/Models";
import {
    CreateMaterialRequestItemEvidence, UpdateMaterialRequestItemEvidence
} from "../../../../../reduxToolkit/MaterialRequest/MaterialRequestApi";
import {ValidateItemComplete} from "../../../../../reduxToolkit/MaterialControl/MaterialControlApi";
import {toast} from "react-toastify";
import {errorMsg} from "../../../../../Apis/functions";
import {FILE_MODEL} from "../../../Visitor/Visitor/Model/Model";
/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 */

export const MaterialRecordDeliveryModalApp =({ onHide, itemSelected, setModified })=> {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const {user} = useSelector((state) => state.authenticatioauthennSlice);
    const [data, setData] = useState({...RECORD_DELIVERY_MODEL});
    const [photoPicker, setPhotoPicker] = useState({ ...PHOTO_PICKER_MODEL });
    const { handleChange } = HandleChange({ model: data, setModel: setData });
    const [displayModal, setDisplayModal] = useState('');
    const [clear, setClear] = useState(false);
    const [emptyFields, setEmptyFields] = useState(false);
    const file = itemSelected?.itemEvidence ? FILE_MODEL.set(itemSelected?.itemEvidence) : null;
    // A material of a folio of material control is read from its own service,
    // so the folio it belongs to is what says which one registers it
    const isMaterialControl = Boolean(itemSelected?.materialControlId);

    /**
     * Effect: Initializes modal form data when an item is selected.
     *
     * Behavior:
     * - Maps selected item information into the local form model.
     * - Loads existing evidence information if available.
     * - Sets preview image and file identifier into the photo picker state.
     */
    useEffect(() => {
        setData(RECORD_DELIVERY_MODEL.set(itemSelected));
        if(file)
            setPhotoPicker((prev) => ({
                ...prev,
                selfieSrc: file?.filePath,
                id: file?.fileId
            }));
    }, [itemSelected]);

    /**
     * Handles the confirmation action for material delivery evidence.
     *
     * Behavior:
     * - Validates required fields and evidence information.
     * - Determines whether the operation is:
     *   - Create evidence
     *   - Update existing evidence
     * - Sends the request to backend service.
     * - Displays success notification.
     * - Refreshes parent information.
     * - Closes modal and clears form state.
     * - Displays backend error messages when request fails.
     *
     * @returns {void}
     */
    const onConfirm = () => {
        if (!data.isValid({ photoPicker })) {
            setEmptyFields(true);
            return;
        }

        // The materials of a folio of material control are validated by the
        // service of the block they belong to, and not by the evidence of a
        // material request, which is what a material of a request is delivered
        // with
        const endPoint = isMaterialControl
            ? ValidateItemComplete
            : (file ? UpdateMaterialRequestItemEvidence : CreateMaterialRequestItemEvidence);

        // The validation of a material control is registered for the user that
        // performs it
        const body = isMaterialControl
            ? MATERIAL_CONTROL_ITEM_VALIDATION_MODEL.toRegister({
                item: itemSelected,
                note: data.note,
                photoPicker,
                userId: user?.data?.id
            })
            : data.toRegister({ file: photoPicker});

        dispatch(endPoint(body))
            .then(({payload:{data:{success, code}}})=>{
            if (success){
                toast.success(t(file ? 'has_been_updated_successfully' : 'has_been_created_successfully'));
                setModified(true);
                onHide();
                setData({...data.clearAll()});
                setPhotoPicker({...PHOTO_PICKER_MODEL});
            }else errorMsg(code)
        });
    }

    /**
     * Resets modal form information to its initial state.
     *
     * Clears:
     * - Delivery form information.
     * - Uploaded evidence files.
     * - Photo picker state.
     *
     * @returns {void}
     */
    const handleClearFields = () =>{
        setData({...data.clear()});
        setPhotoPicker({...PHOTO_PICKER_MODEL});
    }

    return{
        t,
        data,
        handleChange,
        photoPicker,
        setPhotoPicker,
        displayModal,
        setDisplayModal,
        clear,
        setClear,
        emptyFields,
        onConfirm,
        handleClearFields
    }
}
